import createUnistore from 'unistore';
import { Scene } from '../enums/Checkout';

import { ICheckoutState, SceneStage } from './BaseStore';
import CheckoutStore from './CheckoutStore';

const initialState: ICheckoutState = {
  sceneStates: {
    [Scene.LOADING]: {
      stage: SceneStage.Entered,
    },
  },
  isLoading: false,
  isProcessing: false,
  vault: {
    selected: null,
    items: [],
  },

  locale: 'en',
  translation: null,
  tokens: [],
  currentToken: null,
  apms: {
    selected: null,
    items: [],
  },

  options: {
    purchaseInfo: null,
    customerDetails: null,
    businessDetails: null,
    orderDetails: null,
    orderDetailsInitiator: null,
    showSavePaymentMethod: false,
  },

  paymentMethods: {},

  checkoutModules: [],

  submitButton: {
    isDisabled: false,
    isVisible: false,
    message: '',
  },

  error: {
    message: null,
  },

  smallPrint: {
    message: null,
  },

  directDebit: {
    customerName: null,
    customerAddress: null,
    customerIban: null,
  },

  form: {
    inputLabelsVisible: true,
  },

  card: {
    metadata: {
      cvvLength: 3,
      type: null,
      possibleTypes: [],
      cardNumberLength: 0,
    },
    numberField: {
      error: null,
    },
  },

  paymentMethodPopupOverlay: {
    isVisible: false,
  },
};

///////////////////////////////////////////
// API
///////////////////////////////////////////
export const createStore = () =>
  new CheckoutStore(createUnistore(initialState));
